import I1 from '../image/i1.png'
import F1 from '../image/f1.png'
import C3 from '../image/c3.png'
import Fi1 from '../image/fi1.png'

export const heroData = [
    {
        id : 1, 
        name:'Icecream', 
        decp: 'Chocolate & Vanila', 
        price:'$5.25', imagescr:I1
    },
    {
        id : 2, 
        name:'Strawberries', 
        decp: 'Fresh Strawberries', 
        price:'$5.25', imagescr:F1
    },
    {
        id : 3, 
        name:'Chicken Kebab ', 
        decp: 'Mixed Kebab Plate', 
        price:'$5.25', 
        imagescr:C3
    },
    {
        id : 4, 
        name:'Fish Kebab', 
        decp: 'Mixed Fish Kebab', 
        price:'$5.25', 
        imagescr:Fi1
    },
];

export const categories = [
    {
      id: 1,
      name: "Chicken",
      urlParamName: "chicken",
    },
    {
      id: 2,
      name: "Curry",
      urlParamName: "curry",
    },
    {
      id: 3,
      name: "Rice",
      urlParamName: "rice",
    },
    {
      id: 4,
      name: "Fish",
      urlParamName: "fish",
    },
    {
      id: 5,
      name: "Fruits",
      urlParamName: "fruits",
    },
    {
      id: 6,
      name: "Icecream",
      urlParamName: "icecreams",
    },
    {
      id: 7,
      name: "Soft Drinks",
      urlParamName: "drinks",
    },
  ];
